export const uuiElement = {
    widget: 'uui-widget',
    buttonBox: 'uui-button-box',
    anchor: 'uui-anchor',
    inputBox: 'uui-input-box',
    input: 'uui-input',
    placeholder: 'uui-placeholder',
    valueInPlaceholder: 'uui-value-in-placeholder',
    checkbox: 'uui-checkbox',
    checkboxContainer: 'uui-checkbox-container',
    radioInput: 'uui-radioinput',
    icon: 'uui-icon',
    iconPrimary: 'uui-icon-primary',
    count: 'uui-count',
    caption: 'uui-caption',
    label: 'uui-label',
    labeledContainer: 'uui-labeled-container',
    inputLabel: 'uui-input-label',
    invalidMessage: 'uui-invalid-message',
    dropdownBody: 'uui-dropdown-body',
    switchBody: 'uui-switch-body',
    switchToggler: 'uui-switch-toggler',
    ratingStar: 'uui-rating-star',
    tooltipContainer: 'uui-tooltip-container',
    tooltipBody: 'uui-tooltip-body',
    tooltipArrow: 'uui-tooltip-arrow',
    modalBlocker: 'uui-modal-blocker',
    modalWindow: 'uui-modal-window',
    textareaCounter: 'uui-textarea-counter',
    prefixInput: 'uui-input-prefix',
    suffixInput: 'uui-input-suffix',
} as const;

export const uuiMod = {
    enabled: 'uui-enabled',
    disabled: 'uui-disabled',
    readonly: 'uui-readonly',
    focus: 'uui-focus',
    active: 'uui-active',
    invalid: 'uui-invalid',
    checked: 'uui-checked',
    selected: 'uui-selected',
    opened: 'uui-opened',
    loading: 'uui-loading',
} as const;

export const labelMod = {
    left: 'uui-label-left',
    top: 'uui-label-top',
} as const;

export const directionMode = {
    vertical: 'uui-vertical-direction',
    horizontal: 'uui-horizontal-direction',
} as const;

export const uuiMarkers = {
    lockFocus: '-lock-focus',
    clickable: '-clickable',
    draggable: '-draggable',
    scrolledLeft: '-scrolled-left',
    scrolledRight: '-scrolled-right',
    scrolledVertical: '-scrolled-vertical',
} as const;

export const uuiDndState = {
    draggedOut: 'uui-dragged-out',
    dropAccepted: 'uui-drop-accepted',
    dragGhost: 'uui-drag-ghost',
} as const;

export const uuiDataTableHeaderCell = {
    uuiTableHeaderCell: 'uui-table-header-cell',
    uuiTableHeaderCaption: 'uui-table-header-caption',
    uuiTableHeaderCaptionWrapper: 'uui-table-header-caption-wrapper',
    uuiTableHeaderCheckbox: 'uui-table-header-checkbox',
    uuiTableHeaderSortIcon: 'uui-table-header-sort-icon',
    uuiTableHeaderFilterIcon: 'uui-table-header-filter-icon',
    uuiTableHeaderDropdownIcon: 'uui-table-header-dropdown-icon',
} as const;

export const uuiScrollShadows = {
    top: 'uui-scroll-shadow-top',
    topVisible: 'uui-scroll-shadow-top-visible',
    bottom: 'uui-scroll-shadow-bottom',
    bottomVisible: 'uui-scroll-shadow-bottom-visible',
} as const;